var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Contact',{attrs:{"storedData":_vm.storedData,"isComplete":_vm.isComplete},on:{"getStoredData":_vm.handleGetStoredData,"submitAddress":_vm.handleSubmitAddress}})
}
var staticRenderFns = []

export { render, staticRenderFns }